module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_7-69b6cb74fb177bf813067fe2602f7c64.jpg";